import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const ModalTabContent = props => (
  <div
    className={`modalTabContent ${props.shrinkable ? "shrinkable" : ""} ${
      props.scrollable ? "scrollable" : ""
    } ${props.className || ""}`}
  >
    {props.children}
  </div>
);

ModalTabContent.propTypes = {
  shrinkable: PropTypes.bool,
  scrollable: PropTypes.bool,
  children: PropTypeShapes.elementOrArray.isRequired,
  className: PropTypes.string
};

export default ModalTabContent;
